module.exports = __webpack_public_path__ + "lastSlideAlt.jpg?83166eca837e620f3f82318297e4cbb1";